import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.99 13a3 3 0 0 0-3-3h-1.3a3 3 0 0 0-2.968 2.565c-.492 3.357-.738 7.191-.741 11.505-.003 4.297.236 8.085.718 11.366A3 3 0 0 0 11.667 38h1.323a3 3 0 0 0 3-3V13ZM9.981 24.071c.003-4.222.243-7.961.72-11.216a1 1 0 0 1 .99-.855h1.299a1 1 0 0 1 1 1v22a1 1 0 0 1-1 1h-1.323a1 1 0 0 1-.989-.855c-.467-3.177-.7-6.869-.697-11.074Zm24.15-12.996a3 3 0 0 1 3.316 2.647c.366 3.269.55 6.716.553 10.342.002 3.606-.175 7.01-.532 10.212a3 3 0 0 1-4.57 2.213l-15.252-9.52a3.499 3.499 0 0 1-.002-5.936l15.232-9.52a3 3 0 0 1 1.256-.438Zm-15.904 13.72a1.5 1.5 0 0 1 .477-2.066l15.232-9.52a1 1 0 0 1 1.524.736c.357 3.193.538 6.567.54 10.12.002 3.534-.171 6.863-.52 9.99a1 1 0 0 1-1.523.737l-15.252-9.519a1.501 1.501 0 0 1-.478-.477Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Skip-Previous_svg__a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 10,
    width: 31,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.99 13a3 3 0 0 0-3-3h-1.3a3 3 0 0 0-2.968 2.565c-.492 3.357-.738 7.191-.741 11.505-.003 4.297.236 8.085.718 11.366A3 3 0 0 0 11.667 38h1.323a3 3 0 0 0 3-3V13ZM9.981 24.071c.003-4.222.243-7.961.72-11.216a1 1 0 0 1 .99-.855h1.299a1 1 0 0 1 1 1v22a1 1 0 0 1-1 1h-1.323a1 1 0 0 1-.989-.855c-.467-3.177-.7-6.869-.697-11.074Zm24.15-12.996a3 3 0 0 1 3.316 2.647c.366 3.269.55 6.716.553 10.342.002 3.606-.175 7.01-.532 10.212a3 3 0 0 1-4.57 2.213l-15.252-9.52a3.499 3.499 0 0 1-.002-5.936l15.232-9.52a3 3 0 0 1 1.256-.438Zm-15.904 13.72a1.5 1.5 0 0 1 .477-2.066l15.232-9.52a1 1 0 0 1 1.524.736c.357 3.193.538 6.567.54 10.12.002 3.534-.171 6.863-.52 9.99a1 1 0 0 1-1.523.737l-15.252-9.519a1.501 1.501 0 0 1-.478-.477Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Skip-Previous_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h48v48H0z"
  })));
};

var SvgSkipPrevious = styled(SvgComponent).withConfig({
  displayName: "SkipPrevious__SvgSkipPrevious",
  componentId: "sc-1l09qxc-0"
})(["", " ", ""], size, color);
export default SvgSkipPrevious;